import { companyQueryOptions } from '@/hooks/queries/company.queries';
import { useQuery } from '@tanstack/react-query';

export function useCompanyBySlug(slug?: string) {
  const { data, isError, isFetching, isLoading, refetch } = useQuery(companyQueryOptions.bySlug(slug));

  return {
    company: data,
    isError,
    isFetching,
    isLoading,
    refetch,
  };
}
